module.exports = __webpack_public_path__ + "static/media/weather_1.90a338c4.svg";